import { round } from "../../libraries/_helpers";
import { isObjectEmpty } from "../mls-shooting-breakdown/utils";

export function formatPossessionsIntervalsData(data) {
  if (!data) {
    return {
      firstHalf: [],
      secondHalf: [],
      extraTimes: []
    };
  }

  const halfs = {
    firstHalf: [],
    secondHalf: [],
    extraTimes: []
  };  

  data.forEach((el, i) => {
    const {
      home,
      away
    } = el || {};

    const interval = {
      home: home ? round(home) : 0,
      away: away ? round(away) : 0,
      differenceHome: home > away ? round(home - away) : 0,
      differenceAway: away > home ? round(away - home) : 0
    };

    if (i <= 8) {
      halfs.firstHalf = [...halfs.firstHalf, interval];
    }

    if (i > 8 && i < 18) {
      halfs.secondHalf = [...halfs.secondHalf, interval];
    }

    if (i >= 18) {
      halfs.extraTimes = [...halfs.extraTimes, interval];
    }
  });

  return halfs;
}

export function formatPossessionsOverallData(data) {
  if (!data || data.length !== 1) {
    return {
      home: 0,
      away: 0,
      differenceHome: 0,
      differenceAway: 0
    };
  }

  let overall = {};

  data.forEach(el => {
    const {
      home,
      away
    } = el || {};

    overall = {
      home: home ? round(home) : 0,
      away: away ? round(away) : 0,
      differenceHome: home > away ? round(home - away) : 0,
      differenceAway: away > home ? round(away - home) : 0
    };
  });

  return overall;
}

export function formatClubMatchData(data) {
  const clubs = {
    homeClub: {},
    awayClub: {},
  };

  if (isObjectEmpty(data) && !data?.hasOwnProperty('match_statistics_list')) {
    return clubs;
  }
  
  if (isArrayEmpty(data.match_statistics_list)) {
    return clubs;
  }
  
  const teamsData = data.match_statistics_list[0]?.match_statistics?.team_statistics;
  
  if (!teamsData || teamsData.length !== 2) {
    return clubs;
  }
  
  for (const team of teamsData) {
    const {
      team_id,
      team_role,
      three_letter_code,
      team_three_letter_code,
      team_name: fullName
    } = team;
    
    const clubData = {
      clubMatchId: team_id || 0,
      abbreviation: team_three_letter_code || three_letter_code || '',
      fullName: fullName || '',
    };
  
    if (team_role === "home") {
      clubs.homeClub = clubData;
    } else {
      clubs.awayClub = clubData;
    }
  }

  return clubs;
}

export function formatClubPossessionData(data, clubs) {
  const intervals = [];
  if (!clubs || (isObjectEmpty(data) && !data?.hasOwnProperty('match_statistics_list')) || data?.match_statistics_list?.length < 4) {
    return { overall: [], intervals };
  }

  if (isArrayEmpty(data.match_statistics_list)) {
    return { overall: [], intervals };
  }

  const overall = { home: 0, away: 0, differenceHome: 0, differenceAway: 0 };
  const home = [];
  const away = [];
  const sortedData = data.match_statistics_list.sort((a, b) => getSortableScope(a?.match_statistics?.scope) - getSortableScope(b?.match_statistics?.scope));  
   sortedData.forEach(el => {
    if (isObjectEmpty(el) && !el?.hasOwnProperty('match_statistics')) {
      return;
    }

    const {match_statistics} = el;
    const homeClub = match_statistics?.team_statistics?.find(club => club?.team_role === 'home');
    const awayClub = match_statistics?.team_statistics?.find(club => club?.team_role === 'guest');

    if (!(match_statistics?.scope === '45+' || match_statistics?.scope === '90+' || match_statistics?.scope === '105+' || match_statistics?.scope === '120+')) {
      if (match_statistics?.scope === 'match') {
        overall.home = homeClub?.possession_ratio || 0;
        overall.away = awayClub?.possession_ratio || 0;
      } else {
        home.push(homeClub?.possession_ratio);
        away.push(awayClub?.possession_ratio);
      }
    }
  });

  if (home.length !== away.length) {
    return { overall: [overall], intervals };
  }

  for (let i = 0; i < home.length; i++) {
    intervals[i] = { home: home[i], away: away[i] };
  }

  return { overall: [overall], intervals };
}

function getSortableScope(scope) {
  if (!!scope && typeof scope !== "string") {
    return '';
  }
  const intervalsParts = scope.split('-');
  if (!isArrayEmpty(intervalsParts)) {
    if (intervalsParts[0].length === 1) {
      return `0${intervalsParts[0]}`;
    }
    return intervalsParts[0];
  }
  return scope;
}

export function isArrayEmpty(arr = []) {
  return !Array.isArray(arr) || arr.length === 0;
}